<template>
  <main class="identity-verification">
    <!-- Header -->
    <div class="identity-verification__header">
      <div class="identity-verification__header-content">
        <h1 class="identity-verification__title">Identity Verification</h1>
        <p class="identity-verification__subtitle">Complete verification to unlock all features</p>
      </div>
    </div>

    <!-- Content -->
    <div class="identity-verification__content">
      <section class="identity-verification__sections">
        <Accordion
          v-if="organisationDetails && organisationDetails.kyc"
          :info="info"
          @is-active="setActiveTab"
          :verified="organisationDetails.kyc?.email"
          :status="organisationDetails.kyc?.email === true ? 'Approved' : ''"
        />
        <IdentityDocument @is-active="setActiveTab" />
        <LegalDocument @is-active="setActiveTab" />
        <BankInfo @is-active="setActiveTab" />
      </section>
    </div>
  </main>
</template>

<script>
import IdentityDocument from "@/components/setup/IdentityDocument";
import LegalDocument from "@/components/setup/LegalDocument";
import BankInfo from "@/components/setup/BankInfo";
import { computed } from "vue";
import { mapActions, mapGetters } from "vuex";
import Accordion from "@/components/setup/Accordion";
export default {
  name: "IdentityVerification",
  data() {
    return {
      info: {
        title: "Email Verification",
        description: "Assure us that this email address belongs to you.",
      },
      activeTab: "",
    };
  },
  components: {
    Accordion,
    IdentityDocument,
    BankInfo,
    LegalDocument,
  },
  provide() {
    return {
      activeTab: computed(() => this.activeTab),
    };
  },
  created() {
    this.getOrganisationProfile();
  },
  computed: {
    ...mapGetters(["loading"]),
    ...mapGetters("organisationModule", ["organisationDetails"]),
  },
  methods: {
    ...mapActions("organisationModule", ["getOrganisationProfile"]),
    setActiveTab(title) {
      this.activeTab = title;
    },
  },
};
</script>

<style lang="scss" scoped>
.identity-verification {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px;
    border-bottom: 1px solid #E2E8F0;
  }

  &__header-content {
    flex: 1;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }

  &__subtitle {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
  }

  &__content {
    padding: 24px;
  }

  &__sections {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
